import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EditMetaDataComponent} from '../../alerts/seo/edit-meta-data/edit-meta-data.component';
import Swal from 'sweetalert2';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SeoService} from '../../../services/seo.service';

@Component({
  selector: 'app-meta-information',
  templateUrl: './meta-information.component.html',
  styleUrls: ['./meta-information.component.scss']
})
export class MetaInformationComponent implements OnInit {
  @Input() metaData: any;
  @Input() mantenienceMedata: any;
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private serviceModal: NgbModal,
    private seoService: SeoService,
  ) { }

  ngOnInit(): void {
  }

  editMetaData(data): any {
    const modal = this.serviceModal.open(EditMetaDataComponent, {
      centered: true,
      windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-85pr'
    });
    modal.componentInstance.metaDataInfo = JSON.parse(JSON.stringify(data));
    modal.result.then((res) => {
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.seoService.editMetaData(res)
        .subscribe(response => {
          if (response.valid) {
            this.refreshData.emit();
          }
        });
      }, (reason) => {

      });
  }
}
